// SEO landing page config for individual tools, keyed by tool id from tools-snapshot.json.
// Kept separate from tools-snapshot.json because that file is overwritten on every
// `npm run build` (prebuild fetches it fresh from the live API) — SEO copy here survives that.

// `rentName` is the genitive form for "Оренда …" headings, `description` is rental copy that
// replaces the catalog text from the DB, `{dayPrice}` in FAQ answers is filled with the live price.
const toolLandingPages = {
  'tool-001': {
    slug: 'perforator-dewalt-d25144k',
    rentName: { uk: 'перфоратора DeWalt D25144K', ru: 'перфоратора DeWalt D25144K' },
    description: {
      uk: 'Перфоратор DeWalt D25144K напрокат — для ремонту, коли потрібно пробити бетон чи цеглу, а купувати власний інструмент заради кількох отворів немає сенсу. Три режими: свердління, удар і чистове штроблення, енергія удару 3.0 Дж. Завдяки швидкозмінному патрону перфоратор за секунди стає точним дрилем. В оренду видаємо у кейсі TSTAK: патрон SDS-Plus, додатковий швидкозатискний патрон для звичайних свердел і бури 6, 8 та 10 мм. Порада від SmarTOOL: при інтенсивному штробленні змащуйте хвостовики бурів — так робота піде легше.',
      ru: 'Перфоратор DeWalt D25144K напрокат — для ремонта, когда нужно пробить бетон или кирпич, а покупать собственный инструмент ради нескольких отверстий нет смысла. Три режима: сверление, удар и чистовое штробление, энергия удара 3.0 Дж. Благодаря быстросъёмному патрону перфоратор за секунды становится точной дрелью. В аренду выдаём в кейсе TSTAK: патрон SDS-Plus, дополнительный быстрозажимной патрон для обычных свёрл и буры 6, 8 и 10 мм. Совет от SmarTOOL: при интенсивном штроблении смазывайте хвостовики буров — так работа пойдёт легче.',
    },
    keywords: {
      uk: 'оренда перфоратора DeWalt D25144K, прокат перфоратора Харків, оренда перфоратора Харків без застави, оренда SDS-Plus перфоратора, прокат DeWalt Харків, оренда перфоратора з доставкою',
      ru: 'аренда перфоратора DeWalt D25144K, прокат перфоратора Харьков, аренда перфоратора Харьков без залога, аренда SDS-Plus перфоратора, прокат DeWalt Харьков, аренда перфоратора с доставкой',
    },
    faq: [
      {
        q: { uk: 'Чи потрібна застава для оренди перфоратора DeWalt D25144K?', ru: 'Нужен ли залог для аренды перфоратора DeWalt D25144K?' },
        a: {
          uk: 'Ні, застава не потрібна. Для оренди достатньо підтвердити особу через застосунок Дія.',
          ru: 'Нет, залог не требуется. Для аренды достаточно подтвердить личность через приложение Дія.',
        },
      },
      {
        q: { uk: 'Скільки коштує оренда перфоратора на добу?', ru: 'Сколько стоит аренда перфоратора на сутки?' },
        a: {
          uk: 'Оренда на добу коштує від {dayPrice} грн. Усі тарифи вказані на цій сторінці.',
          ru: 'Аренда на сутки стоит от {dayPrice} грн. Все тарифы указаны на этой странице.',
        },
      },
      {
        q: { uk: 'Що входить у комплект перфоратора D25144K?', ru: 'Что входит в комплект перфоратора D25144K?' },
        a: {
          uk: 'Фірмовий кейс TSTAK, швидкозмінний патрон SDS-Plus, додатковий швидкозатискний патрон для звичайних свердел та набір бурів діаметром 6, 8 і 10 мм.',
          ru: 'Фирменный кейс TSTAK, быстросъёмный патрон SDS-Plus, дополнительный быстрозажимной патрон для обычных свёрл и набор буров диаметром 6, 8 и 10 мм.',
        },
      },
      {
        q: { uk: 'Чи є доставка перфоратора по Харкову?', ru: 'Есть ли доставка перфоратора по Харькову?' },
        a: {
          uk: 'Так, доставляємо інструмент по Харкову. Зателефонуйте, щоб уточнити умови та вартість доставки.',
          ru: 'Да, доставляем инструмент по Харькову. Позвоните, чтобы уточнить условия и стоимость доставки.',
        },
      },
      {
        q: { uk: 'Для яких робіт підходить цей перфоратор?', ru: 'Для каких работ подходит этот перфоратор?' },
        a: {
          uk: 'Для свердління, ударного буріння бетону та цегли, а також чистового штроблення під електропроводку — енергія удару 3.0 Дж впевнено проходить навіть твердий бетон.',
          ru: 'Для сверления, ударного бурения бетона и кирпича, а также чистового штробления под электропроводку — энергия удара 3.0 Дж уверенно проходит даже твёрдый бетон.',
        },
      },
    ],
  },

  'tool-009': {
    slug: 'perforator-dewalt-d25614k',
    rentName: { uk: 'відбійного молотка DeWalt D25614K', ru: 'отбойного молотка DeWalt D25614K' },
    description: {
      uk: 'Відбійний молоток DeWalt D25614K в оренду — для демонтажу та руйнування бетону і пробивання отворів під комунікації. Такий інструмент потрібен на кілька днів, тому вигідніше орендувати його, ніж купувати. Система SDS-Max, енергія удару 10.5 Дж, віброгасіння AVC зменшує навантаження на руки, а регулювання обертів дозволяє налаштуватися під щільність матеріалу. В оренду видаємо у фірмовому кейсі з додатковою рукояткою та набором пік. Порада від SmarTOOL: це важкий інструмент — завжди тримайте його за додаткову рукоятку та робіть короткі перерви, щоб ударний механізм охолонув.',
      ru: 'Отбойный молоток DeWalt D25614K в аренду — для демонтажа и разрушения бетона и пробивки отверстий под коммуникации. Такой инструмент нужен на несколько дней, поэтому выгоднее арендовать его, чем покупать. Система SDS-Max, энергия удара 10.5 Дж, виброгашение AVC снижает нагрузку на руки, а регулировка оборотов позволяет настроиться под плотность материала. В аренду выдаём в фирменном кейсе с дополнительной рукояткой и набором пик. Совет от SmarTOOL: это тяжёлый инструмент — всегда держите его за дополнительную рукоятку и делайте короткие перерывы, чтобы ударный механизм остывал.',
    },
    keywords: {
      uk: 'оренда перфоратора DeWalt D25614K, оренда відбійного молотка Харків, прокат SDS-Max перфоратора Харків, оренда відбійного молотка без застави, оренда потужного перфоратора Харків',
      ru: 'аренда перфоратора DeWalt D25614K, аренда отбойного молотка Харьков, прокат SDS-Max перфоратора Харьков, аренда отбойного молотка без залога, аренда мощного перфоратора Харьков',
    },
    faq: [
      {
        q: { uk: 'Чи потрібна застава для оренди відбійного молотка D25614K?', ru: 'Нужен ли залог для аренды отбойного молотка D25614K?' },
        a: { uk: 'Ні. Ідентифікація через застосунок Дія, без грошової застави.', ru: 'Нет. Идентификация через приложение Дія, без денежного залога.' },
      },
      {
        q: { uk: 'Скільки коштує оренда на добу?', ru: 'Сколько стоит аренда на сутки?' },
        a: { uk: 'Від {dayPrice} грн на добу — це потужніший і дорожчий інструмент за звичайний перфоратор.', ru: 'От {dayPrice} грн на сутки — это более мощный и дорогой инструмент, чем обычный перфоратор.' },
      },
      {
        q: { uk: 'Чим ця модель відрізняється від перфоратора D25144K?', ru: 'Чем эта модель отличается от перфоратора D25144K?' },
        a: {
          uk: 'D25614K — це SDS-Max відбійний молоток з енергією удару 10.5 Дж, призначений для важкого демонтажу та руйнування бетону, на відміну від легшого SDS-Plus D25144K для свердління та точного штроблення.',
          ru: 'D25614K — это SDS-Max отбойный молоток с энергией удара 10.5 Дж, предназначенный для тяжёлого демонтажа и разрушения бетона, в отличие от более лёгкого SDS-Plus D25144K для сверления и точного штробления.',
        },
      },
      {
        q: { uk: 'Що входить у комплект?', ru: 'Что входит в комплект?' },
        a: { uk: 'Фірмовий кейс, додаткова рукоятка та набір пік.', ru: 'Фирменный кейс, дополнительная рукоятка и набор пик.' },
      },
      {
        q: { uk: 'Чи важко працювати з таким потужним інструментом?', ru: 'Тяжело ли работать с таким мощным инструментом?' },
        a: {
          uk: 'Це важкий професійний інструмент, тому рекомендуємо завжди використовувати додаткову рукоятку та робити короткі перерви при серійному штробленні.',
          ru: 'Это тяжёлый профессиональный инструмент, поэтому рекомендуем всегда использовать дополнительную рукоятку и делать короткие перерывы при серийном долблении.',
        },
      },
    ],
  },

  'tool-007': {
    slug: 'shtroborez-makita-sg125j',
    rentName: { uk: 'штроборіза Makita SG125J', ru: 'штробореза Makita SG125J' },
    description: {
      uk: 'Штроборіз Makita SG125J напрокат — щоб прокласти проводку в бетоні чи цеглі без пилу від болгарки і без витрат на власний інструмент. Потужність 1400 Вт, глибина штроби до 30 мм, система SJS запобігає ривкам при заклинюванні дисків. Видаємо готовим до роботи: диски вже встановлені. Умови роботи: обов\'язково підключайте будівельний пилосос для охолодження оснастки та чистоти на об\'єкті, його можна орендувати разом зі штроборізом. Працювати по металу та без пиловидалення заборонено.',
      ru: 'Штроборез Makita SG125J напрокат — чтобы проложить проводку в бетоне или кирпиче без пыли от болгарки и без затрат на собственный инструмент. Мощность 1400 Вт, глубина штробы до 30 мм, система SJS предотвращает рывки при заклинивании дисков. Выдаём готовым к работе: диски уже установлены. Условия работы: обязательно подключайте строительный пылесос для охлаждения оснастки и чистоты на объекте, его можно арендовать вместе со штроборезом. Работать по металлу и без пылеудаления запрещено.',
    },
    keywords: {
      uk: 'оренда штроборіза Makita Харків, прокат штроборіза Харків без застави, оренда штроборіза для проводки, оренда Makita SG125J Харків',
      ru: 'аренда штробореза Makita Харьков, прокат штробореза Харьков без залога, аренда штробореза для проводки, аренда Makita SG125J Харьков',
    },
    faq: [
      {
        q: { uk: 'Чи потрібна застава для оренди штроборіза?', ru: 'Нужен ли залог для аренды штробореза?' },
        a: { uk: 'Ні, оренда без грошової застави — лише підтвердження особи через Дія.', ru: 'Нет, аренда без денежного залога — только подтверждение личности через Дія.' },
      },
      {
        q: { uk: 'Скільки коштує оренда штроборіза Makita на добу?', ru: 'Сколько стоит аренда штробореза Makita на сутки?' },
        a: { uk: 'Від {dayPrice} грн на добу.', ru: 'От {dayPrice} грн на сутки.' },
      },
      {
        q: { uk: 'На яку глибину штробить цей інструмент?', ru: 'На какую глубину штробит этот инструмент?' },
        a: { uk: 'До 30 мм у бетоні та цеглі — оптимально для прокладання електропроводки.', ru: 'До 30 мм в бетоне и кирпиче — оптимально для прокладки электропроводки.' },
      },
      {
        q: { uk: 'Чи обов’язково потрібен будівельний пилосос?', ru: 'Обязательно ли нужен строительный пылесос?' },
        a: {
          uk: 'Так, підключення пилососа обов’язкове для охолодження оснастки та чистоти на об’єкті. Радимо орендувати разом з пилососом DeWALT DWV901L.',
          ru: 'Да, подключение пылесоса обязательно для охлаждения оснастки и чистоты на объекте. Советуем арендовать вместе с пылесосом DeWALT DWV901L.',
        },
      },
      {
        q: { uk: 'Чи можна цим штроборізом різати метал?', ru: 'Можно ли этим штроборезом резать металл?' },
        a: { uk: 'Ні, робота по металу заборонена — інструмент призначений лише для бетону та цегли.', ru: 'Нет, работа по металлу запрещена — инструмент предназначен только для бетона и кирпича.' },
      },
    ],
  },

  'tool-017': {
    slug: 'pylosos-dewalt-dwv901l',
    rentName: { uk: 'будівельного пилососа DeWALT DWV901L', ru: 'строительного пылесоса DeWALT DWV901L' },
    description: {
      uk: 'Будівельний пилосос DeWALT DWV901L в оренду — щоб не забивати побутовий пилосос бетонним пилом під час ремонту. Клас L, збирає сухе сміття і негорючі рідини, а автоматичне очищення кожні 30 секунд струшує фільтри, тому сила всмоктування не падає. Вбудована розетка із синхронним стартом вмикає пилосос разом із вашою болгаркою чи штроборізом — зручно орендувати їх комплектом. Порада від SmarTOOL: при роботі по бетону завжди використовуйте мішок для пилу — це подвійна фільтрація.',
      ru: 'Строительный пылесос DeWALT DWV901L в аренду — чтобы не забивать бытовой пылесос бетонной пылью во время ремонта. Класс L, собирает сухой мусор и негорючие жидкости, а автоматическая очистка каждые 30 секунд встряхивает фильтры, поэтому сила всасывания не падает. Встроенная розетка с синхронным стартом включает пылесос вместе с вашей болгаркой или штроборезом — удобно арендовать их комплектом. Совет от SmarTOOL: при работе по бетону всегда используйте мешок для пыли — это двойная фильтрация.',
    },
    keywords: {
      uk: 'оренда будівельного пилососа Харків, прокат промислового пилососа DeWalt Харків, оренда пилососа класу L, оренда пилососа без застави Харків',
      ru: 'аренда строительного пылесоса Харьков, прокат промышленного пылесоса DeWalt Харьков, аренда пылесоса класса L, аренда пылесоса без залога Харьков',
    },
    faq: [
      {
        q: { uk: 'Чи потрібна застава для оренди пилососа?', ru: 'Нужен ли залог для аренды пылесоса?' },
        a: { uk: 'Ні, застава не потрібна — лише ідентифікація через Дія.', ru: 'Нет, залог не требуется — только идентификация через Дія.' },
      },
      {
        q: { uk: 'Скільки коштує оренда пилососа DWV901L?', ru: 'Сколько стоит аренда пылесоса DWV901L?' },
        a: { uk: 'Від {dayPrice} грн на добу.', ru: 'От {dayPrice} грн на сутки.' },
      },
      {
        q: { uk: 'Чи можна збирати цим пилососом рідину?', ru: 'Можно ли этим пылесосом собирать жидкость?' },
        a: { uk: 'Так, він ефективно збирає як сухе будівельне сміття, так і негорючі рідини.', ru: 'Да, он эффективно собирает как сухой строительный мусор, так и негорючие жидкости.' },
      },
      {
        q: { uk: 'Що таке функція синхронного старту?', ru: 'Что такое функция синхронного старта?' },
        a: {
          uk: 'Вбудована розетка дозволяє підключити болгарку чи штроборіз напряму до пилососа — він вмикається та вимикається автоматично разом з інструментом.',
          ru: 'Встроенная розетка позволяет подключить болгарку или штроборез напрямую к пылесосу — он включается и выключается автоматически вместе с инструментом.',
        },
      },
      {
        q: { uk: 'Навіщо потрібен мішок для пилу?', ru: 'Зачем нужен мешок для пыли?' },
        a: {
          uk: 'При роботі зі штроборізом або шліфмашиною по бетону мішок забезпечує подвійну фільтрацію найдрібнішого бетонного пилу.',
          ru: 'При работе со штроборезом или шлифмашиной по бетону мешок обеспечивает двойную фильтрацию мельчайшей бетонной пыли.',
        },
      },
    ],
  },

  'tool-004': {
    slug: 'lobzik-dewalt-dw331k',
    rentName: { uk: 'лобзика DeWalt DW331K', ru: 'лобзика DeWalt DW331K' },
    description: {
      uk: 'Лобзик DeWalt DW331K напрокат — для збирання меблів, вирізів у стільниці чи фанері та інших робіт, де потрібен чистий пропил на день-два. Потужність 701 Вт, різ у дереві до 135 мм і в металі до 12 мм, 4 ступені маятникового ходу та обдування робочої зони. Видаємо зібраним, з однією пилкою по дереву. Порада від SmarTOOL: щоб уникнути сколів і перегріву двигуна, підключайте пилосос і підбирайте швидкість під матеріал.',
      ru: 'Лобзик DeWalt DW331K напрокат — для сборки мебели, вырезов в столешнице или фанере и других работ, где нужен чистый пропил на день-два. Мощность 701 Вт, рез в дереве до 135 мм и в металле до 12 мм, 4 ступени маятникового хода и обдув рабочей зоны. Выдаём собранным, с одной пилкой по дереву. Совет от SmarTOOL: чтобы избежать сколов и перегрева двигателя, подключайте пылесос и подбирайте скорость под материал.',
    },
    keywords: {
      uk: 'оренда лобзика DeWalt Харків, прокат лобзика Харків без застави, оренда лобзика DW331K, оренда електролобзика з доставкою Харків',
      ru: 'аренда лобзика DeWalt Харьков, прокат лобзика Харьков без залога, аренда лобзика DW331K, аренда электролобзика с доставкой Харьков',
    },
    faq: [
      {
        q: { uk: 'Чи потрібна застава для оренди лобзика?', ru: 'Нужен ли залог для аренды лобзика?' },
        a: { uk: 'Ні, ідентифікація через Дія, без грошової застави.', ru: 'Нет, идентификация через Дія, без денежного залога.' },
      },
      {
        q: { uk: 'Скільки коштує оренда лобзика DW331K?', ru: 'Сколько стоит аренда лобзика DW331K?' },
        a: { uk: 'Від {dayPrice} грн на добу.', ru: 'От {dayPrice} грн на сутки.' },
      },
      {
        q: { uk: 'На яку товщину матеріалу розрахований лобзик?', ru: 'На какую толщину материала рассчитан лобзик?' },
        a: { uk: 'До 135 мм у дереві та до 12 мм у металі, завдяки 4-ступінчастому маятниковому ходу.', ru: 'До 135 мм в дереве и до 12 мм в металле, благодаря 4-ступенчатому маятниковому ходу.' },
      },
      {
        q: { uk: 'Скільки пилок у комплекті?', ru: 'Сколько пилок в комплекте?' },
        a: { uk: 'Одна якісна пилка по дереву. Швидкозатискне кріплення дозволяє легко поставити свою.', ru: 'Одна качественная пилка по дереву. Быстрозажимное крепление позволяет легко поставить свою.' },
      },
      {
        q: { uk: 'Чи потрібен пилосос під час роботи?', ru: 'Нужен ли пылесос во время работы?' },
        a: { uk: 'Рекомендується — це запобігає сколам і перегріву двигуна.', ru: 'Рекомендуется — это предотвращает сколы и перегрев двигателя.' },
      },
    ],
  },

  'tool-005': {
    slug: 'tsirkulyarka-dewalt-dwe575k',
    rentName: { uk: 'циркулярної пили DeWalt DWE575K', ru: 'циркулярной пилы DeWalt DWE575K' },
    description: {
      uk: 'Циркулярна пила DeWalt DWE575K в оренду — для рівного розпилу дощок і листових матеріалів на ремонті чи будівництві. Потужність 1600 Вт, глибина різу до 67 мм, нахил підошви до 57 градусів, система пиловидалення та низька вібрація. Видаємо зібраною, з одним універсальним диском по дереву. Умови роботи: не можна пиляти матеріали з цвяхами та працювати затупленим диском.',
      ru: 'Циркулярная пила DeWalt DWE575K в аренду — для ровного распила досок и листовых материалов на ремонте или стройке. Мощность 1600 Вт, глубина реза до 67 мм, наклон подошвы до 57 градусов, система пылеудаления и низкая вибрация. Выдаём собранной, с одним универсальным диском по дереву. Условия работы: нельзя пилить материалы с гвоздями и работать затупленным диском.',
    },
    keywords: {
      uk: 'оренда циркулярної пили Харків, прокат циркулярки DeWalt Харків, оренда дискової пили без застави Харків, оренда DWE575K',
      ru: 'аренда циркулярной пилы Харьков, прокат циркулярки DeWalt Харьков, аренда дисковой пилы без залога Харьков, аренда DWE575K',
    },
    faq: [
      {
        q: { uk: 'Чи потрібна застава для оренди циркулярної пили?', ru: 'Нужен ли залог для аренды циркулярной пилы?' },
        a: { uk: 'Ні, лише ідентифікація через застосунок Дія.', ru: 'Нет, только идентификация через приложение Дія.' },
      },
      {
        q: { uk: 'Скільки коштує оренда циркулярки на добу?', ru: 'Сколько стоит аренда циркулярки на сутки?' },
        a: { uk: 'Від {dayPrice} грн на добу.', ru: 'От {dayPrice} грн на сутки.' },
      },
      {
        q: { uk: 'Яка глибина різу у циркулярної пили DWE575K?', ru: 'Какая глубина реза у циркулярной пилы DWE575K?' },
        a: { uk: 'До 67 мм при потужності 1600 Вт.', ru: 'До 67 мм при мощности 1600 Вт.' },
      },
      {
        q: { uk: 'Чи можна пиляти під кутом?', ru: 'Можно ли пилить под углом?' },
        a: { uk: 'Так, підошву можна нахилити до 57 градусів.', ru: 'Да, подошву можно наклонить до 57 градусов.' },
      },
      {
        q: { uk: 'Які є обмеження при роботі?', ru: 'Какие есть ограничения при работе?' },
        a: {
          uk: 'Заборонено розпилювати матеріали з цвяхами або працювати затупленим диском — це небезпечно для оператора і скорочує ресурс двигуна.',
          ru: 'Запрещено распиливать материалы с гвоздями или работать затупленным диском — это опасно для оператора и сокращает ресурс двигателя.',
        },
      },
    ],
  },

  'tool-003': {
    slug: 'bolgarka-dewalt-dwe4357',
    rentName: { uk: 'болгарки DeWalt DWE4357', ru: 'болгарки DeWalt DWE4357' },
    description: {
      uk: 'Мережева болгарка DeWalt DWE4357 напрокат — різати метал, шліфувати дерево чи полірувати камінь одним інструментом завдяки електронному регулюванню обертів. Безщітковий двигун тримає потужність під навантаженням, а електронна муфта і гальмо миттєво зупиняють диск при заклинюванні. В оренду видаємо із захисним кожухом та антивібраційною рукояткою. Порада від SmarTOOL: завжди підбирайте оберти під оснастку — результат буде кращим.',
      ru: 'Сетевая болгарка DeWalt DWE4357 напрокат — резать металл, шлифовать дерево или полировать камень одним инструментом благодаря электронной регулировке оборотов. Бесщёточный двигатель держит мощность под нагрузкой, а электронная муфта и тормоз мгновенно останавливают диск при заклинивании. В аренду выдаём с защитным кожухом и антивибрационной рукояткой. Совет от SmarTOOL: всегда подбирайте обороты под оснастку — результат будет лучше.',
    },
    keywords: {
      uk: 'оренда болгарки Харків, прокат болгарки DeWalt Харків, оренда кутової шліфмашини без застави, оренда УШМ Харків з доставкою',
      ru: 'аренда болгарки Харьков, прокат болгарки DeWalt Харьков, аренда угловой шлифмашины без залога, аренда УШМ Харьков с доставкой',
    },
    faq: [
      {
        q: { uk: 'Чи потрібна застава для оренди болгарки?', ru: 'Нужен ли залог для аренды болгарки?' },
        a: { uk: 'Ні, оренда без застави — ідентифікація через Дія.', ru: 'Нет, аренда без залога — идентификация через Дія.' },
      },
      {
        q: { uk: 'Скільки коштує оренда болгарки DWE4357?', ru: 'Сколько стоит аренда болгарки DWE4357?' },
        a: { uk: 'Від {dayPrice} грн на добу.', ru: 'От {dayPrice} грн на сутки.' },
      },
      {
        q: { uk: 'Для яких матеріалів підходить ця болгарка?', ru: 'Для каких материалов подходит эта болгарка?' },
        a: {
          uk: 'Завдяки електронному регулюванню обертів вона однаково ефективно ріже метал, шліфує дерево та полірує камінь.',
          ru: 'Благодаря электронной регулировке оборотов она одинаково эффективно режет металл, шлифует дерево и полирует камень.',
        },
      },
      {
        q: { uk: 'Чи входить диск у комплект?', ru: 'Входит ли диск в комплект?' },
        a: {
          uk: 'У комплекті йде захисний кожух та антивібраційна рукоятка. Наявність конкретного диска уточнюйте при бронюванні під ваше завдання.',
          ru: 'В комплекте идёт защитный кожух и антивибрационная рукоятка. Наличие конкретного диска уточняйте при бронировании под вашу задачу.',
        },
      },
      {
        q: { uk: 'Чи безпечна ця болгарка для не дуже досвідченого користувача?', ru: 'Безопасна ли эта болгарка для не очень опытного пользователя?' },
        a: {
          uk: 'Так, електронна муфта та гальмо двигуна миттєво зупиняють диск при заклинюванні, що значно підвищує безпеку.',
          ru: 'Да, электронная муфта и тормоз двигателя мгновенно останавливают диск при заклинивании, что значительно повышает безопасность.',
        },
      },
    ],
  },

  'tool-019': {
    slug: 'bolgarka-akkumulyatorna-dewalt-dcg416b',
    rentName: { uk: 'акумуляторної болгарки DeWalt DCG416B', ru: 'аккумуляторной болгарки DeWalt DCG416B' },
    description: {
      uk: 'Акумуляторна болгарка DeWalt DCG416B в оренду — для робіт на об\'єкті, де немає розетки. Диски 125 мм, до 9000 об/хв, безщітковий двигун. Електронна муфта E-CLUTCH вимикає мотор при заклинюванні, а гальмо Kickback Brake миттєво зупиняє оснастку. В оренду видаємо з акумулятором 20V 5.0 Ah та зарядним пристроєм. Порада від SmarTOOL: батареї вистачає для інтенсивного різання металу чи профілю, але на довгих важких роботах підзаряджайте її у перервах.',
      ru: 'Аккумуляторная болгарка DeWalt DCG416B в аренду — для работ на объекте, где нет розетки. Диски 125 мм, до 9000 об/мин, бесщёточный двигатель. Электронная муфта E-CLUTCH отключает мотор при заклинивании, а тормоз Kickback Brake мгновенно останавливает оснастку. В аренду выдаём с аккумулятором 20V 5.0 Ah и зарядным устройством. Совет от SmarTOOL: батареи хватает для интенсивной резки металла или профиля, но на долгих тяжёлых работах подзаряжайте её в перерывах.',
    },
    keywords: {
      uk: 'оренда акумуляторної болгарки Харків, прокат акумуляторної болгарки DeWalt Харків, оренда бездротової кутової шліфмашини без застави, оренда DeWalt DCG416B Харків, оренда болгарки 125 мм на акумуляторі',
      ru: 'аренда аккумуляторной болгарки Харьков, прокат аккумуляторной болгарки DeWalt Харьков, аренда беспроводной угловой шлифмашины без залога, аренда DeWalt DCG416B Харьков, аренда болгарки 125 мм на аккумуляторе',
    },
    faq: [
      {
        q: { uk: 'Чи потрібна застава для оренди акумуляторної болгарки DCG416B?', ru: 'Нужен ли залог для аренды аккумуляторной болгарки DCG416B?' },
        a: { uk: 'Ні, оренда без грошової застави — лише підтвердження особи через застосунок Дія.', ru: 'Нет, аренда без денежного залога — только подтверждение личности через приложение Дія.' },
      },
      {
        q: { uk: 'Скільки коштує оренда болгарки DCG416B?', ru: 'Сколько стоит аренда болгарки DCG416B?' },
        a: { uk: 'Від {dayPrice} грн на добу.', ru: 'От {dayPrice} грн на сутки.' },
      },
      {
        q: { uk: 'Чим ця болгарка відрізняється від мережевої DWE4357?', ru: 'Чем эта болгарка отличается от сетевой DWE4357?' },
        a: {
          uk: 'DCG416B працює від акумулятора 20V, тому нею зручно різати та шліфувати там, де немає розетки — на даху, у дворі, на об’єкті без електрики. Диск 125 мм, до 9000 об/хв, безщітковий двигун.',
          ru: 'DCG416B работает от аккумулятора 20V, поэтому ею удобно резать и шлифовать там, где нет розетки — на крыше, во дворе, на объекте без электричества. Диск 125 мм, до 9000 об/мин, бесщёточный двигатель.',
        },
      },
      {
        q: { uk: 'Що входить у комплект?', ru: 'Что входит в комплект?' },
        a: { uk: 'Акумулятор 20V 5.0 Ah, зарядний пристрій та захисний кожух.', ru: 'Аккумулятор 20V 5.0 Ah, зарядное устройство и защитный кожух.' },
      },
      {
        q: { uk: 'На скільки вистачає заряду акумулятора?', ru: 'На сколько хватает заряда аккумулятора?' },
        a: {
          uk: 'Батареї 5.0 Ah вистачає на інтенсивне різання металу чи профілю протягом робочої зміни з перервами. Для тривалих важких робіт радимо підзаряджати акумулятор у перервах або взяти запасний.',
          ru: 'Батареи 5.0 Ah хватает на интенсивную резку металла или профиля в течение рабочей смены с перерывами. Для длительных тяжёлых работ советуем подзаряжать аккумулятор в перерывах или взять запасной.',
        },
      },
    ],
  },

  'tool-012': {
    slug: 'multitul-dewalt-dwe315kt',
    rentName: { uk: 'мультитула (реноватора) DeWALT DWE315KT', ru: 'мультитула (реноватора) DeWALT DWE315KT' },
    description: {
      uk: 'Мультитул (реноватор) DeWALT DWE315KT напрокат — для точних робіт у важкодоступних місцях: підрізати плінтус, зачистити шви, врізати розетку в готову панель або зняти старий клей. Насадки міняються без ключа, робочу зону підсвічує LED. В оренду видаємо у кейсі TSTAK з базовими насадками для різання та шліфування. Порада від SmarTOOL: не тисніть на інструмент — дайте йому працювати за рахунок вібрації, так полотно не перегріється, а зріз буде чистим.',
      ru: 'Мультитул (реноватор) DeWALT DWE315KT напрокат — для точных работ в труднодоступных местах: подрезать плинтус, зачистить швы, врезать розетку в готовую панель или снять старый клей. Насадки меняются без ключа, рабочую зону подсвечивает LED. В аренду выдаём в кейсе TSTAK с базовыми насадками для резки и шлифовки. Совет от SmarTOOL: не давите на инструмент — дайте ему работать за счёт вибрации, так полотно не перегреется, а срез будет чистым.',
    },
    keywords: {
      uk: 'оренда мультитула Харків, прокат реноватора DeWalt Харків, оренда мультитула без застави, оренда DWE315KT Харків',
      ru: 'аренда мультитула Харьков, прокат реноватора DeWalt Харьков, аренда мультитула без залога, аренда DWE315KT Харьков',
    },
    faq: [
      {
        q: { uk: 'Чи потрібна застава для оренди мультитула?', ru: 'Нужен ли залог для аренды мультитула?' },
        a: { uk: 'Ні, застава не потрібна — ідентифікація через Дія.', ru: 'Нет, залог не требуется — идентификация через Дія.' },
      },
      {
        q: { uk: 'Скільки коштує оренда мультитула (реноватора)?', ru: 'Сколько стоит аренда мультитула (реноватора)?' },
        a: { uk: 'Від {dayPrice} грн на добу.', ru: 'От {dayPrice} грн на сутки.' },
      },
      {
        q: { uk: 'Для яких робіт підходить реноватор?', ru: 'Для каких работ подходит реноватор?' },
        a: {
          uk: 'Для підрізання плінтусів, зачистки швів, врізки розеток у готові панелі та акуратного зняття старого клею.',
          ru: 'Для подрезания плинтусов, зачистки швов, врезки розеток в готовые панели и аккуратного снятия старого клея.',
        },
      },
      {
        q: { uk: 'Що входить у комплект?', ru: 'Что входит в комплект?' },
        a: { uk: 'Фірмовий кейс TSTAK та набір базових насадок для різання і шліфування.', ru: 'Фирменный кейс TSTAK и набор базовых насадок для резки и шлифовки.' },
      },
      {
        q: { uk: 'Чи легко користуватись мультитулом без досвіду?', ru: 'Легко ли пользоваться мультитулом без опыта?' },
        a: {
          uk: 'Так, система швидкої зміни насадок без ключа та яскраве LED-підсвічування роблять роботу зручною навіть для новачка.',
          ru: 'Да, система быстрой смены насадок без ключа и яркая LED-подсветка делают работу удобной даже для новичка.',
        },
      },
    ],
  },

  'tool-018': {
    slug: 'gaikovert-dewalt-dcf900',
    rentName: { uk: 'гайковерта DeWALT DCF900', ru: 'гайковерта DeWALT DCF900' },
    description: {
      uk: 'Гайковерт DeWALT DCF900 в оренду — замінити колеса чи гальмівні диски, змонтувати металоконструкції або відкрутити прикипілі болти, де звичайний шуруповерт не впорається. Квадрат 1/2", 1400 Нм на зривання та 1030 Нм на затяжку, 4 режими швидкості. Режим Precision Wrench захищає від перетягування різьби. В оренду видаємо з акумулятором, зарядним пристроєм і кейсом. Порада від SmarTOOL: з тонким металом починайте на нижньому режимі — так різьба залишиться цілою.',
      ru: 'Гайковёрт DeWALT DCF900 в аренду — заменить колёса или тормозные диски, смонтировать металлоконструкции или открутить прикипевшие болты, где обычный шуруповёрт не справится. Квадрат 1/2", 1400 Нм на срыв и 1030 Нм на затяжку, 4 режима скорости. Режим Precision Wrench защищает от перетягивания резьбы. В аренду выдаём с аккумулятором, зарядным устройством и кейсом. Совет от SmarTOOL: с тонким металлом начинайте на нижнем режиме — так резьба останется целой.',
    },
    keywords: {
      uk: 'оренда гайковерта Харків, прокат ударного гайкового ключа DeWalt Харків, оренда гайковерта без застави, оренда DCF900',
      ru: 'аренда гайковёрта Харьков, прокат ударного гайковёрта DeWalt Харьков, аренда гайковёрта без залога, аренда DCF900',
    },
    faq: [
      {
        q: { uk: 'Чи потрібна застава для оренди гайковерта?', ru: 'Нужен ли залог для аренды гайковёрта?' },
        a: { uk: 'Ні, ідентифікація через Дія, без грошової застави.', ru: 'Нет, идентификация через Дія, без денежного залога.' },
      },
      {
        q: { uk: 'Скільки коштує оренда гайковерта DCF900?', ru: 'Сколько стоит аренда гайковёрта DCF900?' },
        a: { uk: 'Від {dayPrice} грн на добу.', ru: 'От {dayPrice} грн на сутки.' },
      },
      {
        q: { uk: 'Для яких робіт підходить цей гайковерт?', ru: 'Для каких работ подходит этот гайковёрт?' },
        a: {
          uk: 'Для заміни коліс і гальмівних дисків, монтажу металоконструкцій, встановлення анкерних болтів у бетон та обслуговування важкої техніки.',
          ru: 'Для замены колёс и тормозных дисков, монтажа металлоконструкций, установки анкерных болтов в бетон и обслуживания тяжёлой техники.',
        },
      },
      {
        q: { uk: 'Наскільки він потужний?', ru: 'Насколько он мощный?' },
        a: {
          uk: 'Крутний момент 1400 Нм на зривання та 1030 Нм на затяжку — на 47% потужніше за попередню модель.',
          ru: 'Крутящий момент 1400 Нм на срыв и 1030 Нм на затяжку — на 47% мощнее предыдущей модели.',
        },
      },
      {
        q: { uk: 'Що входить у комплект?', ru: 'Что входит в комплект?' },
        a: { uk: 'Акумулятор, зарядний пристрій та кейс.', ru: 'Аккумулятор, зарядное устройство и кейс.' },
      },
    ],
  },

  'tool-002': {
    slug: 'shurupovert-dewalt-dcd796',
    rentName: { uk: 'шуруповерта DeWalt DCD796', ru: 'шуруповёрта DeWalt DCD796' },
    description: {
      uk: 'Ударний шуруповерт DeWalt DCD796 напрокат — зібрати меблі, повісити карнизи, закрутити саморізи чи просвердлити цеглу без покупки власного інструменту. Безщітковий двигун, 70 Нм крутного моменту, функція удару. В оренду видаємо два акумулятори, 2 Аг і 5 Аг, швидкий зарядний пристрій та комплект біт — працювати можна без пауз на зарядку. Порада від SmarTOOL: для щільних матеріалів використовуйте другу швидкість, а саморізи в дерево закручуйте на першій, щоб не зірвати шліци.',
      ru: 'Ударный шуруповёрт DeWalt DCD796 напрокат — собрать мебель, повесить карнизы, закрутить саморезы или просверлить кирпич без покупки собственного инструмента. Бесщёточный двигатель, 70 Нм крутящего момента, функция удара. В аренду выдаём два аккумулятора, 2 Ач и 5 Ач, быстрое зарядное устройство и комплект бит — работать можно без пауз на зарядку. Совет от SmarTOOL: для плотных материалов используйте вторую скорость, а саморезы в дерево закручивайте на первой, чтобы не сорвать шлицы.',
    },
    keywords: {
      uk: 'оренда шуруповерта Харків, прокат шуруповерта DeWalt Харків, оренда акумуляторного шуруповерта без застави, оренда DCD796',
      ru: 'аренда шуруповёрта Харьков, прокат шуруповёрта DeWalt Харьков, аренда аккумуляторного шуруповёрта без залога, аренда DCD796',
    },
    faq: [
      {
        q: { uk: 'Чи потрібна застава для оренди шуруповерта?', ru: 'Нужен ли залог для аренды шуруповёрта?' },
        a: { uk: 'Ні, тільки ідентифікація через Дія.', ru: 'Нет, только идентификация через Дія.' },
      },
      {
        q: { uk: 'Скільки коштує оренда шуруповерта DCD796?', ru: 'Сколько стоит аренда шуруповёрта DCD796?' },
        a: { uk: 'Від {dayPrice} грн на добу.', ru: 'От {dayPrice} грн на сутки.' },
      },
      {
        q: { uk: 'Скільки акумуляторів у комплекті?', ru: 'Сколько аккумуляторов в комплекте?' },
        a: {
          uk: 'Два: 2 Аг для легких робіт на висоті та 5 Аг для тривалих силових навантажень — можна працювати без пауз на зарядку.',
          ru: 'Два: 2 Ач для лёгких работ на весу и 5 Ач для длительных силовых нагрузок — можно работать без пауз на зарядку.',
        },
      },
      {
        q: { uk: 'Чи можна свердлити цеглу цим шуруповертом?', ru: 'Можно ли сверлить кирпич этим шуруповёртом?' },
        a: {
          uk: 'Так, завдяки крутному моменту 70 Нм і функції удару він легко замінює звичайний дриль для цегли та легкого бетону.',
          ru: 'Да, благодаря крутящему моменту 70 Нм и функции удара он легко заменяет обычную дрель для кирпича и лёгкого бетона.',
        },
      },
      {
        q: { uk: 'Що входить у комплект?', ru: 'Что входит в комплект?' },
        a: { uk: 'Два акумулятори, швидкий зарядний пристрій та набір якісних біт.', ru: 'Два аккумулятора, быстрое зарядное устройство и набор качественных бит.' },
      },
    ],
  },

  'tool-015': {
    slug: 'dril-dewalt-dwd014s',
    rentName: { uk: 'дриля DeWalt DWD014S', ru: 'дрели DeWalt DWD014S' },
    description: {
      uk: 'Дриль DeWalt DWD014S напрокат — легкий безударний інструмент для свердління металу, дерева та пластику. Швидкозатискний патрон міняє свердла за секунди, а мала вага дозволяє працювати однією рукою у важкодоступних місцях. Електронне регулювання швидкості дає повний контроль. Порада від SmarTOOL: найкраще він працює зі свердлами малих і середніх діаметрів, не навантажуйте його великими коронками по дереву.',
      ru: 'Дрель DeWalt DWD014S напрокат — лёгкий безударный инструмент для сверления металла, дерева и пластика. Быстрозажимной патрон меняет свёрла за секунды, а малый вес позволяет работать одной рукой в труднодоступных местах. Электронная регулировка скорости даёт полный контроль. Совет от SmarTOOL: лучше всего она работает со свёрлами малых и средних диаметров, не нагружайте её большими коронками по дереву.',
    },
    keywords: {
      uk: 'оренда дриля Харків, прокат дриля-шуруповерта DeWalt Харків, оренда безударного дриля без застави, оренда DWD014S',
      ru: 'аренда дрели Харьков, прокат дрели-шуруповёрта DeWalt Харьков, аренда безударной дрели без залога, аренда DWD014S',
    },
    faq: [
      {
        q: { uk: 'Чи потрібна застава для оренди дриля?', ru: 'Нужен ли залог для аренды дрели?' },
        a: { uk: 'Ні, ідентифікація через Дія, без грошової застави.', ru: 'Нет, идентификация через Дія, без денежного залога.' },
      },
      {
        q: { uk: 'Скільки коштує оренда дриля DWD014S?', ru: 'Сколько стоит аренда дрели DWD014S?' },
        a: { uk: 'Від {dayPrice} грн на добу — це наш найбюджетніший інструмент.', ru: 'От {dayPrice} грн на сутки — это наш самый бюджетный инструмент.' },
      },
      {
        q: { uk: 'Чи підходить цей дриль для свердління бетону?', ru: 'Подходит ли эта дрель для сверления бетона?' },
        a: {
          uk: 'Ні, це безударна модель — вона призначена для точного свердління металу, дерева та пластику, а не ударного буріння.',
          ru: 'Нет, это безударная модель — она предназначена для точного сверления металла, дерева и пластика, а не ударного бурения.',
        },
      },
      {
        q: { uk: 'Наскільки швидко можна замінити свердло?', ru: 'Насколько быстро можно заменить сверло?' },
        a: { uk: 'Швидкозатискний патрон дозволяє замінити свердло за секунди без ключа.', ru: 'Быстрозажимной патрон позволяет заменить сверло за секунды без ключа.' },
      },
      {
        q: { uk: 'Чи можна використовувати великі коронки по дереву?', ru: 'Можно ли использовать крупные коронки по дереву?' },
        a: {
          uk: 'Не рекомендується — модель створена для високої швидкості й точності та найкраще проявляє себе зі свердлами малих і середніх діаметрів.',
          ru: 'Не рекомендуется — модель создана для высокой скорости и точности и лучше всего проявляет себя со свёрлами малых и средних диаметров.',
        },
      },
    ],
  },

  'tool-016': {
    slug: 'tehnichnyi-fen-dewalt-d26411',
    rentName: { uk: 'технічного фена DeWalt D26411', ru: 'технического фена DeWalt D26411' },
    description: {
      uk: 'Технічний фен DeWalt D26411 в оренду — зняти стару фарбу чи лак, сформувати пластикові труби, зробити термоусадку або просушити поверхню. Дві настройки температури, система охолодження для роботи без перегріву, ергономічна рукоятка. В оренду видаємо у фірмовому кейсі з насадками для спрямування повітря. Порада від SmarTOOL: після роботи на максимальній температурі дайте фену 30 секунд попрацювати на мінімальному режимі.',
      ru: 'Технический фен DeWalt D26411 в аренду — снять старую краску или лак, сформовать пластиковые трубы, сделать термоусадку или просушить поверхность. Две настройки температуры, система охлаждения для работы без перегрева, эргономичная рукоятка. В аренду выдаём в фирменном кейсе с насадками для направления воздуха. Совет от SmarTOOL: после работы на максимальной температуре дайте фену 30 секунд поработать на минимальном режиме.',
    },
    keywords: {
      uk: 'оренда технічного фена Харків, прокат будівельного фена DeWalt Харків, оренда промислового фена без застави, оренда D26411',
      ru: 'аренда технического фена Харьков, прокат строительного фена DeWalt Харьков, аренда промышленного фена без залога, аренда D26411',
    },
    faq: [
      {
        q: { uk: 'Чи потрібна застава для оренди технічного фена?', ru: 'Нужен ли залог для аренды технического фена?' },
        a: { uk: 'Ні, лише ідентифікація через Дія.', ru: 'Нет, только идентификация через Дія.' },
      },
      {
        q: { uk: 'Скільки коштує оренда фена D26411?', ru: 'Сколько стоит аренда фена D26411?' },
        a: { uk: 'Від {dayPrice} грн на добу.', ru: 'От {dayPrice} грн на сутки.' },
      },
      {
        q: { uk: 'Для яких робіт підходить цей фен?', ru: 'Для каких работ подходит этот фен?' },
        a: {
          uk: 'Для видалення старої фарби та лаку, формування пластикових труб, термоусадки та просушування поверхонь.',
          ru: 'Для удаления старой краски и лака, формовки пластиковых труб, термоусадки и просушки поверхностей.',
        },
      },
      {
        q: { uk: 'Скільки режимів температури має фен?', ru: 'Сколько температурных режимов у фена?' },
        a: { uk: 'Два налаштування температури та потужна система охолодження для інтенсивної роботи без перегріву.', ru: 'Две настройки температуры и мощная система охлаждения для интенсивной работы без перегрева.' },
      },
      {
        q: { uk: 'Що входить у комплект?', ru: 'Что входит в комплект?' },
        a: { uk: 'Фірмовий кейс та набір спеціальних насадок для точного спрямування повітряного потоку.', ru: 'Фирменный кейс и набор специальных насадок для точного направления воздушного потока.' },
      },
    ],
  },

  'tool-008': {
    slug: 'shlifmashina-dewalt-dwe6423',
    rentName: { uk: 'шліфмашини DeWalt DWE6423', ru: 'шлифмашины DeWalt DWE6423' },
    description: {
      uk: 'Ексцентрикова шліфмашина DeWalt DWE6423 напрокат — відновити меблі або зняти стару фарбу чи лак без покупки інструменту на один проєкт. Електронне регулювання обертів і низький корпус дають рівний результат, а пиловидалення дозволяє працювати в приміщенні. В оренду видаємо з пилозбірником та стартовим набором шліфувальних кругів. Порада від SmarTOOL: не тисніть на машину — її ваги достатньо, а зайвий натиск перегріває підошву.',
      ru: 'Эксцентриковая шлифмашина DeWalt DWE6423 напрокат — восстановить мебель или снять старую краску или лак без покупки инструмента на один проект. Электронная регулировка оборотов и низкий корпус дают ровный результат, а пылеудаление позволяет работать в помещении. В аренду выдаём с пылесборником и стартовым набором шлифовальных кругов. Совет от SmarTOOL: не давите на машину — её веса достаточно, а лишний нажим перегревает подошву.',
    },
    keywords: {
      uk: 'оренда шліфмашини Харків, прокат ексцентрикової шліфмашини DeWalt Харків, оренда шліфувальної машини без застави, оренда DWE6423',
      ru: 'аренда шлифмашины Харьков, прокат эксцентриковой шлифмашины DeWalt Харьков, аренда шлифовальной машины без залога, аренда DWE6423',
    },
    faq: [
      {
        q: { uk: 'Чи потрібна застава для оренди шліфмашини?', ru: 'Нужен ли залог для аренды шлифмашины?' },
        a: { uk: 'Ні, ідентифікація через Дія, без грошової застави.', ru: 'Нет, идентификация через Дія, без денежного залога.' },
      },
      {
        q: { uk: 'Скільки коштує оренда шліфмашини DWE6423?', ru: 'Сколько стоит аренда шлифмашины DWE6423?' },
        a: { uk: 'Від {dayPrice} грн на добу.', ru: 'От {dayPrice} грн на сутки.' },
      },
      {
        q: { uk: 'Для яких робіт підходить ця шліфмашина?', ru: 'Для каких работ подходит эта шлифмашина?' },
        a: { uk: 'Для делікатного шліфування меблів та зняття старої фарби чи лаку.', ru: 'Для деликатной шлифовки мебели и снятия старой краски или лака.' },
      },
      {
        q: { uk: 'Чи входять шліфувальні круги в комплект?', ru: 'Входят ли шлифовальные круги в комплект?' },
        a: { uk: 'Так, у комплекті йде фірмовий пилозбірник та стартовий набір шліфувальних кругів.', ru: 'Да, в комплекте идёт фирменный пылесборник и стартовый набор шлифовальных кругов.' },
      },
      {
        q: { uk: 'Чи потрібно сильно тиснути на машину під час роботи?', ru: 'Нужно ли сильно давить на машину во время работы?' },
        a: {
          uk: 'Ні, ваги самого інструменту достатньо для якісного шліфування — зайвий тиск лише перегріє підошву.',
          ru: 'Нет, веса самого инструмента достаточно для качественной шлифовки — лишний нажим только перегреет подошву.',
        },
      },
    ],
  },

  'tool-006': {
    slug: 'detektor-provodky-bosch-gms120-27',
    rentName: { uk: 'детектора проводки Bosch GMS 120-27', ru: 'детектора проводки Bosch GMS 120-27' },
    description: {
      uk: 'Детектор проводки Bosch GMS 120-27 напрокат — перевірити стіну перед свердлінням, щоб не пошкодити комунікації. Знаходить приховану проводку під напругою, чорні та кольорові метали до 120 мм і дерев\'яні конструкції. Як користуватися: зніміть металеві прикраси з рук, щільно притискайте прилад до поверхні та ведіть плавно, без відриву. Детектор може не бачити знеструмлені дроти або глибоко прокладений пластик.',
      ru: 'Детектор проводки Bosch GMS 120-27 напрокат — проверить стену перед сверлением, чтобы не повредить коммуникации. Находит скрытую проводку под напряжением, чёрные и цветные металлы до 120 мм и деревянные конструкции. Как пользоваться: снимите металлические украшения с рук, плотно прижимайте прибор к поверхности и ведите плавно, без отрыва. Детектор может не видеть обесточенные провода или глубоко проложенный пластик.',
    },
    keywords: {
      uk: 'оренда детектора проводки Харків, прокат детектора металу Bosch Харків, оренда сканера стін без застави, оренда GMS 120-27',
      ru: 'аренда детектора проводки Харьков, прокат детектора металла Bosch Харьков, аренда сканера стен без залога, аренда GMS 120-27',
    },
    faq: [
      {
        q: { uk: 'Чи потрібна застава для оренди детектора проводки?', ru: 'Нужен ли залог для аренды детектора проводки?' },
        a: { uk: 'Ні, лише ідентифікація через Дія.', ru: 'Нет, только идентификация через Дія.' },
      },
      {
        q: { uk: 'Скільки коштує оренда детектора Bosch GMS 120-27?', ru: 'Сколько стоит аренда детектора Bosch GMS 120-27?' },
        a: { uk: 'Від {dayPrice} грн на добу.', ru: 'От {dayPrice} грн на сутки.' },
      },
      {
        q: { uk: 'Що саме визначає цей прилад?', ru: 'Что именно определяет этот прибор?' },
        a: {
          uk: 'Приховану проводку під напругою, чорні та кольорові метали на глибині до 120 мм та дерев’яні конструкції в стінах.',
          ru: 'Скрытую проводку под напряжением, чёрные и цветные металлы на глубине до 120 мм и деревянные конструкции в стенах.',
        },
      },
      {
        q: { uk: 'Чи бачить детектор знеструмлені дроти?', ru: 'Видит ли детектор обесточенные провода?' },
        a: {
          uk: 'Не завжди — прилад може не бачити знеструмлені дроти або пластик, що залягає глибоко, тому свердлити варто обережно.',
          ru: 'Не всегда — прибор может не видеть обесточенные провода или глубоко залегающий пластик, поэтому сверлить стоит осторожно.',
        },
      },
      {
        q: { uk: 'Як правильно користуватись детектором?', ru: 'Как правильно пользоваться детектором?' },
        a: {
          uk: 'Зніміть металеві прикраси з рук, щільно притискайте прилад до поверхні та ведіть його плавно, без відриву від стіни.',
          ru: 'Снимите металлические украшения с рук, плотно прижимайте прибор к поверхности и ведите его плавно, без отрыва от стены.',
        },
      },
    ],
  },
};

export default toolLandingPages;

export function findToolLandingPageBySlug(slug) {
  const entry = Object.entries(toolLandingPages).find(([, cfg]) => cfg.slug === slug);
  if (!entry) return null;
  const [toolId, config] = entry;
  return { toolId, ...config };
}

// Display name overrides for tools whose DB name isn't fit for public pages
const TOOL_NAME_OVERRIDES = {
  'tool-009': { uk: 'Відбійний молоток DeWalt D25614K', ru: 'Отбойный молоток DeWalt D25614K' },
};

export const getToolName = (tool, language) =>
  TOOL_NAME_OVERRIDES[tool?.id]?.[language] || tool?.name?.[language] || tool?.name?.uk || '';

export const getRentalDescription = (tool, language) =>
  toolLandingPages[tool?.id]?.description?.[language] || tool?.description?.[language] || tool?.description?.uk || '';
